var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading && _vm.balance
            ? _c("div", [
                _c("div", { staticClass: "flex flex_gap_10" }, [
                  _c("div", { staticClass: "card bg-success" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("h5", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              (_vm.activeBalance ?? 0).toLocaleString("ru-RU")
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card bg-info" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("p", [
                        _vm._v("Баланс на "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.printDate(
                                _vm.balance.actual_date,
                                "DD.MM.YYYY"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h5", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              (
                                _vm.balance?.balance?.[33]?.orders ?? 0
                              ).toLocaleString("ru-RU")
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "table",
                    { staticClass: "table table-hover table-sm mt-1" },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm._l(
                            _vm.getSortedRecord(),
                            function (records, timestamp, ii) {
                              return _vm._l(records, function (record, i) {
                                return _c("tr", { class: { odd: ii % 2 } }, [
                                  _c("td", [_vm._v(_vm._s(i + 1))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("i", {
                                      class: {
                                        "icon-fa": true,
                                        "icon-fa-minus-square":
                                          record.operation === "-",
                                        "icon-fa-plus-square":
                                          record.operation === "+",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      record.typeAlias === "income"
                                        ? [
                                            _c("p", [_vm._v("Инкассация")]),
                                            _vm._v(" "),
                                            +record.type_id === 2
                                              ? [
                                                  _c("p", [
                                                    _vm._v("обмен на Tether"),
                                                  ]),
                                                ]
                                              : [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "text-muted",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$AllDivisions[
                                                            record.division_id
                                                          ]?.title
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "text-muted",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(record.comment)
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                          ]
                                        : [
                                            _c("p", [
                                              _vm._v(_vm._s(record.type.title)),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "text-muted" },
                                              [_vm._v(_vm._s(record.comment))]
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("strong", [_vm._v(_vm._s(record.sum))]),
                                  ]),
                                  _vm._v(" "),
                                  i === 0
                                    ? _c(
                                        "td",
                                        {
                                          staticClass: "group_date",
                                          attrs: { rowspan: records.length },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.printDate(
                                                  record.timestamp,
                                                  "DD.MM.YYYY"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", { attrs: { align: "right" } }, [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          record.balance_change.toLocaleString(
                                            "ru-RU"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              })
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Операции за период")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_vm._v("Баланс на "), _c("strong", [_vm._v("сегодня")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("сальдо")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }